import { notification } from 'tea-component';

import { buriedBtnPoint } from '@home/utils/buriedPoint';
import { dbhBtnLogMes } from '@home/utils/buriedPointCfg';

interface IUrlCollectionLogConfigItem {
  buttonId: string;
  pageId: string;
  typeId: string;
  extInfo?: string;
}

export const URL_COLLECTION_LOG_CONFIG = {
  addShortcut: dbhBtnLogMes.homeShortcutsAdd,
  clickShortcut: dbhBtnLogMes.homeShortcutsClick,
  clickMore: dbhBtnLogMes.homeNewFeaturesMore,
  clickFeature: dbhBtnLogMes.homeNewFeaturesClick,
};

const PATH_PREFIX_REGEXP = /^(?:rebuildv\d+|v\d+)[\s/_:-]*/i;

export const showShortcutNotification = (type: 'success' | 'error', description: string): void => {
  const config = {
    unique: true,
    description,
    duration: 3000,
  };

  if (type === 'success') {
    notification.success(config);
    return;
  }

  notification.error(config);
};

export const logUrlCollectionButtonClick = (
  config: IUrlCollectionLogConfigItem,
  extInfo: Record<string, unknown>,
): void => {
  const extInfoStr = JSON.stringify(extInfo);

  buriedBtnPoint({
    ...config,
    extInfo: config.extInfo ? `${config.extInfo}: ${extInfoStr}` : extInfoStr,
  });
};

export const formatShortcutPageName = (pageName = ''): string => {
  return pageName.replace(PATH_PREFIX_REGEXP, '').trim();
};
